module.exports = __webpack_public_path__ + "static/media/ic_plc_men.78b51d9a.svg";